import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { serverUrlAuth } from '../../serverUrl';

export default function withAuth(Component, role = null, requirePremium = false) {
  return function AuthWrapper(props) {
    const token = localStorage.getItem('access_token');
    const userRole = localStorage.getItem('role');
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false); // default to false

    useEffect(() => {
      if (!token) return;

      const checkAccess = async () => {
        if (!requirePremium) {
          setHasAccess(true);
          setLoading(false);
          return;
        }

        try {
          const res = await serverUrlAuth.get('users/ready-products-payment-status/');
          setHasAccess(res.data.has_paid_ready_products);
        } catch (err) {
          console.error(err);
          setHasAccess(false);
        } finally {
          setLoading(false);
        }
      };

      checkAccess();
    }, [token, requirePremium]);

    // 1️⃣ Not logged in
    if (!token) {
      toast.info('Please log in');
      return <Navigate to="/login" replace />;
    }

    // 2️⃣ Wrong role
    if (role && userRole !== role) {
      toast.info('You are unauthorized to view that page');
      return <Navigate to="/unauthorized" replace />;
    }

    // ⏳ Wait for premium check
    if (loading) {
      return <div>Loading...</div>;
    }

    // 3️⃣ Block access if premium required but user hasn't paid
    if (requirePremium && !hasAccess) {
      toast.info('Upgrade required to access this page');
      return <Navigate to="/artisan-dashboard" replace />;
    }

    // 4️⃣ Prevent logged-in users from visiting login page
    if (location.pathname === '/login') {
      if (userRole === 'client') return <Navigate to="/client-dashboard" replace />;
      if (userRole === 'artisan') return <Navigate to="/artisan-dashboard" replace />;
      if (userRole === 'admin') return <Navigate to="/admin-dashboard" replace />;
    }

    // ✅ Otherwise, render normally
    return <Component {...props} />;
  };
}
